module.exports = __webpack_public_path__ + "img/Атрофия или синдром Зудека.0380eddc.jpg";